import { CAPITAL_GLOBAL_PAYMENT_PRODUCT_TYPE } from '@/features/proposals/hooks/capital-global/use-capital-global-proposal-payment-types.hook';
import {
  buildPremiumPeriodicityOptionsFromCatalog,
  type CapitalGlobalPremiumPeriodicityOption,
} from '@/features/proposals/components/capital-global/utils/capital-global-installment-periodicity.util';
import { useInstallmentTypes } from '@/features/proposals/hooks/use-installment-types.hook';

export function useCapitalGlobalProposalInstallmentTypes() {
  const query = useInstallmentTypes(CAPITAL_GLOBAL_PAYMENT_PRODUCT_TYPE);
  const premiumPeriodicityOptions = buildPremiumPeriodicityOptionsFromCatalog(
    query.data ?? []
  );

  return {
    ...query,
    premiumPeriodicityOptions,
    isCatalogReady: !query.isLoading && !query.isError,
    isCatalogEmpty:
      !query.isLoading &&
      !query.isError &&
      premiumPeriodicityOptions.length === 0,
  };
}

export type { CapitalGlobalPremiumPeriodicityOption };
